export function getPaddedString(sourceString, targetLength, padString) {
  var targetLen = targetLength >> 0;
  var padStr = padString;
  if (sourceString.length > targetLen) {
    return sourceString;
  } else {
    targetLen = targetLen - sourceString.length;
    if (targetLen > padStr.length) {
      padStr += padStr.repeat(targetLen / padStr.length);
    }
    return padStr.slice(0, targetLen) + sourceString;
  }
}
export function getTrackingCategory(isOfferCard) {
  return isOfferCard ? 'card' : 'Card_JK';
}